/**
 * 盖章区域标准坐标预设（与 sign_store_sealrule.coordinate_system 一致）
 * 1: 600×600 触摸区 → 800×600 逻辑（与小程序 checkin-seal-overlay 一致）
 * 2: 全屏 → 0–10000 归一化
 * 3: 800×600 等比
 * 4: 600×600 等比
 */
export const SEAL_AREA_PRESETS = [
  {
    id: 'legacy-square',
    label: '600×600变形(小程序)',
    hint: '触摸区正方形，逻辑 800×600',
    width: 800,
    height: 600,
    coordinateSystem: 1,
    canvasMode: 'inline',
    aspectRatio: '1 / 1'
  },
  {
    id: 'fullscreen',
    label: '全屏(0–10000)',
    hint: '全屏弹层，归一化 0–10000',
    width: 10000,
    height: 10000,
    coordinateSystem: 2,
    canvasMode: 'fullscreen',
    aspectRatio: null
  },
  {
    id: '800x600',
    label: '800×600',
    hint: '逻辑坐标 800×600',
    width: 800,
    height: 600,
    coordinateSystem: 3,
    canvasMode: 'inline',
    aspectRatio: '800 / 600'
  },
  {
    id: '600x600',
    label: '600×600',
    hint: '逻辑坐标 600×600',
    width: 600,
    height: 600,
    coordinateSystem: 4,
    canvasMode: 'inline',
    aspectRatio: '1 / 1'
  }
]

export const DEFAULT_SEAL_AREA_ID = '800x600'

export function getSealAreaPreset(areaId) {
  return SEAL_AREA_PRESETS.find((item) => item.id === areaId) || SEAL_AREA_PRESETS.find((p) => p.id === DEFAULT_SEAL_AREA_ID) || SEAL_AREA_PRESETS[0]
}

export function isSealFullscreenMode(areaId) {
  return getSealAreaPreset(areaId).canvasMode === 'fullscreen'
}

function clampStandardCoord(value, max) {
  const num = Number(value)
  if (!Number.isFinite(num)) return 0
  return Math.max(0, Math.min(max, Math.round(num)))
}

/**
 * 触摸点映射到标准坐标（逻辑坐标，非画布像素）
 * 与小程序 checkin-seal-overlay：standardX = x/rect.width*800, standardY = y/rect.height*600
 */
export function mapTouchToStandard(touch, rect, areaId) {
  const preset = getSealAreaPreset(areaId)
  const displayX = touch.clientX - rect.left
  const displayY = touch.clientY - rect.top
  const ratioX = rect.width > 0 ? displayX / rect.width : 0
  const ratioY = rect.height > 0 ? displayY / rect.height : 0
  return {
    displayX,
    displayY,
    standardX: clampStandardCoord(ratioX * preset.width, preset.width),
    standardY: clampStandardCoord(ratioY * preset.height, preset.height)
  }
}

/** 提交前再次归一化 */
export function normalizeSealStandardPoints(points, areaId) {
  const preset = getSealAreaPreset(areaId)
  if (!Array.isArray(points)) return []
  return points.map((point) => {
    if (!Array.isArray(point) || point.length < 2) return [0, 0]
    return [
      clampStandardCoord(point[0], preset.width),
      clampStandardCoord(point[1], preset.height)
    ]
  })
}

/** 组装提交给后端的点位参数 */
export function buildSealPointsSubmitPayload(points, areaId) {
  const preset = getSealAreaPreset(areaId)
  return {
    points: normalizeSealStandardPoints(points, areaId),
    coordinateSystem: preset.coordinateSystem,
    standardWidth: preset.width,
    standardHeight: preset.height
  }
}
